<script setup lang="ts">
import type { SizeVariants } from '~kui/types/kui';

export interface Props {
  padding?: Extract<SizeVariants, 'xs' | 'sm' | 'md' | 'lg' | 'xl'> | 'none';
  elevation?: Extract<SizeVariants, 'xs' | 'sm' | 'md' | 'lg'> | 'none';
  rounding?:
    | Extract<
      SizeVariants,
        'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl'
    >
    | 'full'
    | 'none';
  omitBackground?: boolean;
  overflow?: 'scroll' | 'hidden' | 'auto' | 'none' | 'visible';
  imagePath?: string;
}

const props = withDefaults(defineProps<Props>(), {
  padding: 'md',
  elevation: 'md',
  rounding: 'lg',
  omitBackground: false,
  overflow: 'hidden',
});

const classList = computed(() => {
  return twMerge(
    cva('relative', {
      variants: {
        padding: {
          none: '',
          xs: 'p-1',
          sm: 'p-2',
          md: 'p-4',
          lg: 'p-6',
          xl: 'p-4 md:p-8',
        },
        elevation: {
          none: '',
          xs: 'shadow-xs',
          sm: 'shadow-sm',
          md: 'shadow-md',
          lg: 'shadow-lg',
        },
        rounding: {
          'none': '',
          'sm': 'rounded-sm',
          'md': 'rounded-md',
          'lg': 'rounded-lg',
          'xl': 'rounded-xl',
          '2xl': 'rounded-2xl',
          '3xl': 'rounded-3xl',
          '4xl': 'rounded-4xl',
          'full': 'rounded-full',
        },
        omitBackground: {
          true: '',
          false: 'bg-white',
        },
        overflow: {
          auto: 'overflow-auto',
          hidden: 'overflow-hidden',
          scroll: 'overflow-scroll',
          visible: 'overflow-visible',
          none: '',
        },
      },
    })({
      padding: props.padding,
      elevation: props.elevation,
      rounding: props.rounding,
      omitBackground: props.omitBackground,
      overflow: props.overflow,
    }),
  );
});
</script>

<template>
  <div :class="classList">
    <NuxtImg
      v-if="imagePath"
      :src="imagePath"
      alt=""
      role="presentation"
      class="h-15 w-auto absolute -top-4 -right-4"
    />
    <slot />
  </div>
</template>
